import React, { Component } from "react";
import { connect } from "react-redux";
import { Field, reduxForm, reset } from "redux-form";
import _ from "lodash";
import Button from "react-bootstrap-button-loader";
import Loader from "react-loader-spinner";
import { Modal } from "react-bootstrap";
import { showError, showSuccess } from "ReduxErrorBar";
import {
  openCheckoutModal,
  makePayment,
  makeStripePayment,
  updateCheckoutDetails,
} from "CheckoutAction";
import { COMMON_FAIL_MESSAGE } from "Constants";
import StripeCheckoutForm from "./stripecheckoutform.js";
import LocaleStrings from "Languages";

const querystring = require("querystring");

class CheckoutDialog extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
    };
  }

  closeModal = () => {
    this.props.openCheckoutModal(false, {});
  };

  onTokenReceived = (token, error) => {
    // debugger;
    if (!error) {
      this.setState({ loading: true });

      var stripeData = {
        source: token.id,
        amount: this.props.price.amount,
        currency: "usd",
        receipt_email: this.props.price.email,
        description: this.props.price.description,
      };

      var stripeString = querystring.stringify(stripeData);

      this.props.makeStripePayment(
        stripeString,
        this.props.session,
        (result) => {
          if (result.error === 1) {
            var errorMessage = result.data.message.replace(/&quot;/g, '"');
            var errorJson = JSON.parse(errorMessage);
            this.props.showError(this.handleStripeError(errorJson.error.code));
            this.setState({ loading: false });
          } else {
            var paymentReponse = result.data;

            var cardDetails = { last4digit: "", fundingtype: "", cardid: "" };
            if (token.card) {
              cardDetails = {
                ...cardDetails,
                last4digit: token.card.last4,
                fundingtype: token.card.funding,
                cardid: token.card.id,
              };
            }

            cardDetails = {
              ...cardDetails,
              card_brand: paymentReponse.source.brand,
            };

            var values = {
              tokenid: paymentReponse.id,
              amount: paymentReponse.amount,
              type: token.type,
              email: this.props.price.email,
              clientip: token.client_ip,
              balance_transaction: paymentReponse.balance_transaction,
              receipt_url: paymentReponse.receipt_url,
              refund_url: paymentReponse.refunds.url,
              package: this.props.price.package,
              eventid: this.props.session.eventid,
              user: this.props.session.userid,
            };

            values = { ...values, ...cardDetails };

            this.props.makePayment(values, this.props.session, (result) => {
              //debugger;
              if (result.error === 1) {
                this.props.showError(COMMON_FAIL_MESSAGE);
                this.setState({ loading: false });
              } else {
                //this.props.reset();
                this.closeModal();
                this.props.showSuccess(
                  LocaleStrings.publish_stripe_payment_success
                );
              }
              this.setState({ loading: false });
            });
          }
        }
      );
    } else {
      this.props.showError(error.message);
    }
  };

  handleStripeError = (errorCode) => {
    if (errorCode === "expired_card") {
      return LocaleStrings.publish_stripe_error_expired_card;
    } else if (errorCode === "card_declined") {
      return LocaleStrings.publish_stripe_error_card_declined;
    } else if (errorCode === "incorrect_cvc") {
      return LocaleStrings.publish_stripe_error_incorrect_cvc;
    } else if (errorCode === "incorrect_number") {
      return LocaleStrings.publish_stripe_error_incorrect_number;
    } else if (errorCode === "invalid_expiry_month") {
      return LocaleStrings.publish_stripe_error_invalid_expiry_month;
    } else if (errorCode === "invalid_expiry_year") {
      return LocaleStrings.publish_stripe_error_invalid_expiry_year;
    } else if (errorCode === "invalid_number") {
      return LocaleStrings.publish_stripe_error_invalid_number;
    } else if (errorCode === "processing_error") {
      return LocaleStrings.publish_stripe_error_processing_error;
    } else if (errorCode === "sepa_unsupported_account") {
      return LocaleStrings.publish_stripe_error_sepa_unsupported_account;
    } else if (errorCode === "invalid_card_type") {
      return LocaleStrings.publish_stripe_error_invalid_card_type;
    }
  };

  render() {
    return (
      <Modal
        className="modal-container"
        show={this.props.showModal === true ? true : false}
        onHide={this.closeModal}
        animation={true}
      >
        <Modal.Body height={350}>
          <div className="import-header">
            <div className="import-modal-title">
              {LocaleStrings.publish_text_checkout}
            </div>
            <button
              type="button"
              className="close btn-sm btn-close "
              onClick={() => this.closeModal()}
              style={{ marginTop: -25 }}
            >
              <span aria-hidden="true">&times;</span>
            </button>
          </div>

          <div style={{ textAlign: "center", marginTop: 20 }}>
            {this.state.loading ? (
              <Loader type="Oval" color="#4da1ff" />
            ) : (
              <StripeCheckoutForm
                amount={this.props.price.amount}
                email={this.props.price.email}
                onTokenReceived={this.onTokenReceived}
              />
            )}
          </div>
        </Modal.Body>
      </Modal>
    );
  }
}

function mapStateToProps(state) {
  return {
    session: state.session,
    showModal: state.showCheckoutModal,
    price: state.updateCheckoutDetails,
    user: state.user,
  };
}

function validate(values) {}

export default connect(mapStateToProps, {
  showError,
  showSuccess,
  openCheckoutModal,
  updateCheckoutDetails,
  makeStripePayment,
  makePayment,
})(
  reduxForm({
    form: "CheckoutEmailForm",
    validate,
    enableReinitialize: true,
  })(CheckoutDialog)
);
